import { CardBrandRow } from "./types";
import { formatMoney, formatPercent } from "./helpers";

export function CardBrands({ rows }: { rows: CardBrandRow[] }) {
  const totalAmount = rows.reduce((acc, r) => acc + r.amount, 0);
  const totalCount = rows.reduce((acc, r) => acc + r.count, 0);

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
      <h2 className="text-sm font-semibold text-gray-900">Card brands</h2>

      {rows.length === 0 ? (
        <p className="mt-3 text-sm text-gray-400">No card transactions recorded.</p>
      ) : (
        <table className="mt-3 min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Brand</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Transactions</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
              <th className="px-3 py-2 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Share</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {rows.map((r) => (
              <tr key={r.brand}>
                <td className="px-3 py-2 text-sm font-medium text-gray-900">{r.brand}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-700">{r.count.toLocaleString()}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-900 font-medium">{formatMoney(r.amount)}</td>
                <td className="px-3 py-2 text-sm text-right text-gray-500">
                  {formatPercent(totalAmount > 0 ? r.amount / totalAmount : 0)}
                </td>
              </tr>
            ))}
            <tr className="bg-gray-50 font-semibold">
              <td className="px-3 py-2 text-sm text-gray-900">Total</td>
              <td className="px-3 py-2 text-sm text-right text-gray-900">{totalCount.toLocaleString()}</td>
              <td className="px-3 py-2 text-sm text-right text-gray-900">{formatMoney(totalAmount)}</td>
              <td className="px-3 py-2 text-sm text-right text-gray-900">100%</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}
